import React, { createContext, useContext, useState } from "react";

/** TaskList item example
 * {
		taskId: 1,
		mediaType: 'facebook',
		status: 'conference',
		title: 'Mihael Varificantare',
		queue: 'IRV_quelle_1167676776767676asdadadas',
		lastmessage: 'I can ask one more question',
		quantity: '0', // new messages count
		timer: ''
	}
 */
const initialState = {
  taskList: [] /* list of all the tasks goes here */,
  selectedTaskId: null /* selected task id stored */,
};

export const ACTIONS = {
  ADD: "add",
  UPDATE: "update",
  REMOVE: "remove",
  SELECT: "select",
  CLEAR: "clear"
};
var prefs = new gadgets.Prefs();
var activateNewTasksAutomatically = prefs.getString('activateNewTasksAutomatically') === '' ? true : prefs.getBool('activateNewTasksAutomatically');
const StoreContext = createContext({});

export const useStore = () => useContext(StoreContext);

export const TaskListStoreProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const getNextSelectedTaskId = (_state, action) => {
    let currentTaskIndex = _state.taskList.indexOf(action.task);
    // if this is the only element in array
    let newSelectedTaskId = null;
    // else get id of next element
    if (_state.taskList.length > 1) {
      // if this is last element
      if (currentTaskIndex === _state.taskList.length - 1) {
        newSelectedTaskId = _state.taskList[currentTaskIndex - 1]?.taskId;
      } else {
        newSelectedTaskId = _state.taskList[currentTaskIndex + 1]?.taskId;
      }
    }
    return newSelectedTaskId;
  };

  const handleActions = (action) => {
    switch (action.type) {
      case ACTIONS.ADD:
        setState((_state) => {
          return {
            taskList: [..._state.taskList, action.task],
            selectedTaskId: activateNewTasksAutomatically ? action.task.taskId : _state.taskList.length
              ? _state.selectedTaskId
              : action.task.taskId,
          };
        });
        break;

      case ACTIONS.UPDATE:
        setState((_state) => ({
          ..._state,
          taskList: _state.taskList.map((task) => {
            if (task.taskId === action.task.taskId) {
              return action.task;
            }
            return task;
          }),
        }));
        break;

      case ACTIONS.REMOVE:
        setState((_state) => {
          const nextSelectedTaskId = getNextSelectedTaskId(_state, action);
          const taskList = _state.taskList.filter(
            (task) => task.taskId !== action.task.taskId
          );
          return {
            taskList: taskList.map((task) => {
                if (task.taskId === nextSelectedTaskId) {
                  task.quantity = 0;
                  return task;
                } else {
                  return task;
                }
              }),
            selectedTaskId: nextSelectedTaskId,
          }
        });
        break;

      case ACTIONS.SELECT:
        setState((_state) => {
          return {
            taskList: _state.taskList.map((task) => {
              if (task.taskId === action.task.taskId) {
                task.quantity = 0;
                return task;
                // return { ...task, quantity: 0 };
              }
              return task;
            }),
            selectedTaskId: action.task.taskId,
          };
        });
        break;
      case ACTIONS.CLEAR:
        setState(initialState);
        break;

      default:
        console.log("Unknown action", action);
        return;
    }
  };

  return (
    <StoreContext.Provider value={[state, handleActions]}>
      {children}
    </StoreContext.Provider>
  );
};